export default __webpack_public_path__ + "static/media/autotest.de5449e9.jpg";